import { useState } from "react";
import { ICodeDataGridColumn } from "../../components/CondensedCodeDataGrid/types";
import { format } from "fecha";
import { EnumRelatorio, RelatorioModel, getTipoRelatorio } from "../../models/relatorios/RelatorioModel";
import { IFiltroRelatorioCotacoes } from "./types";
import CodeUtil from "../../utils/CodeUtil";
import { SessionManager } from "../../utils/SessionManager";
import { RelatorioService } from "../../services/RelatorioService";
import { ShowToast } from "../../components/CodeToast";
import { UNKOWN_EXCEPTION } from "../../utils/Constants";

export const useRelatorioExportarNotasPage = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [showFiltros, setShowFiltros] = useState<boolean>(false);
    const [dataSource, setDataSource] = useState<RelatorioModel[]>([]);
    const [filtroCotacoes, setFiltroCotacoes] = useState<IFiltroRelatorioCotacoes>({
        dataInicial: format(CodeUtil.addDays(-30, new Date(Date.now())), 'YYYY-MM-DD'),
        dataFinal: format(new Date(Date.now()), 'YYYY-MM-DD')
    });

    const columns: ICodeDataGridColumn[] = [
        { title: "Data", property: "data", alignment: "center", onFormatValue: (item: RelatorioModel) => <span>{format(item.data, "DD/MM/YYYY HH:mm")}</span> },
        { title: "Arquivo", property: "relatorio", onFormatValue: (item: RelatorioModel) => <span>{getTipoRelatorio(item.tipo)}</span> },
        { title: "Link", property: "link", onFormatValue: (item: RelatorioModel) => <a href={item.link} target="_blank" rel="noreferrer">{item.link}</a> },
    ]

    const handleExportarArquivos = (params: IFiltroRelatorioCotacoes) => {
        setShowFiltros(false);
        setLoading(true);
        setFiltroCotacoes({ ...filtroCotacoes, ...params });

        RelatorioService.exportarNotasCotacoesAsync(params)
            .then(async (report) => {
                if (!report) {
                    ShowToast({ message: "Erro desconhecido ao gerar o arquivo. Tente novamente mais tarde." });
                    return;
                }

                const downloadLink = CodeUtil.generateCSVTempFileUrl(report);
                setDataSource([{
                    data: new Date(Date.now()),
                    tipo: EnumRelatorio.EXPORTACAO_NOTAS_FISCAIS,
                    isSelected: true,
                    link: downloadLink,
                    usuarioId: SessionManager.getSession().user?.id ?? 0
                }, ...dataSource]);

            }).catch((error) => {
                console.log(error);
                ShowToast({ message: UNKOWN_EXCEPTION });
            }).finally(() => {
                setLoading(false);
            });
    }

    return {
        loading, columns,
        showFiltros, setShowFiltros,
        filtroCotacoes, setFiltroCotacoes,
        dataSource, handleExportarArquivos
    }
}